module.exports = import("https://esm.run/@google/generative-ai");;